var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServices7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\t.st0{fill:#73BE2F;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,15H7c-1.33496,0-2.59033,0.52051-3.53564,1.46484C2.52002,17.40918,2,18.66406,2,20v3  c0,0.55273,0.44775,1,1,1s1-0.44727,1-1v-3c0-0.79004,0.32031-1.5625,0.87842-2.12109C5.4458,17.3125,6.19922,17,7,17h7  c0.78955,0,1.5625,0.32031,2.12109,0.87891S17,19.21094,17,20v3c0,0.55273,0.44727,1,1,1s1-0.44727,1-1v-3  c0-1.33496-0.52051-2.59082-1.46484-3.53516S15.33496,15,14,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,14c2.75684,0,5-2.24316,5-5s-2.24316-5-5-5s-5,2.24316-5,5S7.74316,14,10.5,14z M10.5,6  c1.6543,0,3,1.3457,3,3s-1.3457,3-3,3s-3-1.3457-3-3S8.8457,6,10.5,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.70703,9.29297c-0.39062-0.39062-1.02344-0.39062-1.41406,0L21,12.58594l-1.29297-1.29297  c-0.39062-0.39062-1.02344-0.39062-1.41406,0s-0.39062,1.02344,0,1.41406l2,2C20.48828,14.90234,20.74414,15,21,15  s0.51172-0.09766,0.70703-0.29297l4-4C26.09766,10.31641,26.09766,9.68359,25.70703,9.29297z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices7);
export default __webpack_public_path__ + "static/media/services7.0de90164d9772c590b7953636562e85b.svg";
export { ForwardRef as ReactComponent };